import {defineStore} from 'pinia'
import {ProductApi} from "@/api/product.apis";
import {CommonNs, type ProductNs} from "@shared/types";
import {WorkspaceApi} from "@/api";


export const useProductStore = defineStore("product", {
    state: () => ({
        productList: [] as ProductNs.Product[],
        currentProduct: {} as ProductNs.Product,
    }),
    getters: {},
    actions: {
        async loadProducts(): Promise<ProductNs.Product[]> {
            return ProductApi.getProductList().then((response) => {
                this.productList = response;
                return response;
            });
        },

        async getCurrentProduct(): Promise<ProductNs.Product> {
            return WorkspaceApi.getCurrentProduct().then((response) => {
                this.currentProduct = response;
                return response;
            });
        },

        async cancelSubscription(data: ProductNs.CancelSubscriptionRequest): Promise<CommonNs.AnyResponse> {
            return ProductApi.cancelSubscription(data);
        },

        async changeProduct(data: ProductNs.UpdateProductRequest): Promise<CommonNs.AnyResponse> {
            return ProductApi.changeProduct(data);
        },

        async changeQuantity(data: ProductNs.UpdateProductRequest): Promise<CommonNs.AnyResponse> {
            return ProductApi.changeQuantity(data);
        },
    }
})
